<script>
	import BaseLayout, {$$render} from '../Layout.vue'
	
	export default {
		name: 'col_',
		
		mixins: [BaseLayout],
		
		props: {
			dir: {
				type: String,
				default: 'hori'
			},
			
			wrap: {
				type: Boolean,
				default: false
			}
		},
		
		render(c){
			return $$render.call(this, c)
		}
	}
</script>

<style>
</style>
